import { Component  } from "react";
import NestedTitlePicture from '../Components/NestedTitlePicture/NestedTitlePicture'
import RestranscripteursPicture from '../assets/home/thonon_home_picture.jpeg'
import VisitUs from '../Components/VisitUs/VisitUs'
import { FaEnvelope, FaClock, FaMobile, FaMapMarkerAlt } from 'react-icons/fa'
import React from 'react';
import {globals,setCookies, removeCookies} from '../Components/Globals/Globals';
import ContactForm from "../Components/ContactForm/ContactForm.tsx";
import DailyWorshipText from "../Components/DailyWorshipText/DailyWorshipText";
import CookieConsent from "react-cookie-consent";
import EventsRawTable from "../Components/EventsRawTable/EventsRawTable";
import {loadEvents} from "../redux/eventSlice"
import { useDispatch, useSelector } from "react-redux";

const HomeView = props => {
    let title_color = "white"
    let title_font_size = "3em"
    let container_width = "100%"
    let container_height = "350px"

    const dispatch  = useDispatch();
    const {loadEvents_result, eventsItems} = useSelector((state)=> state.events)
    const {isAuthenticated} = useSelector((state) => state.auth);

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (loadEvents_result.status === 'idle'){
            if (globals.parameters.redux_debugging) alert("event will be loaded")
            dispatch(loadEvents())
        }

        if (loadEvents_result.status === 'succedeed'){
            if (globals.parameters.redux_debugging) alert("event successfully loaded")
            console.log("HomeView:eventsItems ->", eventsItems)
        }
        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [loadEvents_result, dispatch, isAuthenticated]);

    return(
        <div className="view-container">
            <CookieConsent
                location="bottom"
                buttonText="Je comprends."
                style={{ background: "#2B373B" }}
                buttonStyle={{ color: "#4e503b", fontSize: "20px", background:"white" }}>
                    Ce site Web utilise des cookies pour améliorer l'expérience utilisateur.
            </CookieConsent>
            {/*** Picture banner */}
            <div>
                <NestedTitlePicture 
                        width={container_width}
                        height={container_height}
                        pictureTitle = {"Eglise Adventiste du 7ème jour de Thonon"}
                        pictureURL={RestranscripteursPicture}
                        color={title_color}
                        fontSize={title_font_size}
                        />    
            </div>

            {/*** Contact pastor */}
            <div className="subtitle">Contacter notre pasteur</div>
            
            <div className={`pasteur-container ${isAuthenticated?"editable":""}`} 
                    contenteditable={isAuthenticated?"true":"false"}
                    onClick={(obj)=>{console.log("obj->",obj);obj.target.contentEdiatble="true"}}>
                    {/** Photo pasteur + Identité */}
                <div className="pasteur-photo">
                    {/** Photo pasteur + message button*/}
                </div>

                <div className="pasteur-identity">
                    {/** Notre pasteur */}
                    <h3>Eugenio ROMANO</h3>
                    <div><a href= "mailto:eugenio.romano@adventiste.org">eugenio.romano@adventiste.org</a></div>
                    <div><a href= "tel:+33687712352">+33 6 87 71 23 52</a></div>   
                </div>
            </div>
            
            {/** Daily Worship */}
            <div>
                <div className="subtitle">Méditation du jour</div>
                <p>Avec Dieu chaque jour Méditez chaque jour un passage biblique tiré des écrits de <i>Ellen Gould White</i>. Quel que soit votre questionnement, 
                    vos doutes, vos épreuves; Nous avons la conviction que <strong>Jésus</strong> est la réponse !</p>
                <DailyWorshipText shorten={true}/>

                <a className="dropdown-item rounded-button" href="/dailyworship">Lire la méditation...</a>
            </div>

            {/** Diary */}
            
            {true && 
            <div>
                <EventsRawTable
                    event_list={eventsItems}
                    read_only={false}
                    grid={true}
                    emptyresult = {<></>}
                    get_next = {true} 
                    limit = {3}
                    />
            </div>}

            {/** Recevoir  une  Bible  gratuite */}
            <div className="subtitle">Recevoir une Bible gratuitement</div>
            
            
            
            {/*** CONTACT US */}
            <div className="subtitle">Nous rejoindre</div>
            <div className="contact-container">
                {/** Map + Contact */} 
                <div className="contact-map">
                    <VisitUs/>
                </div>

                {/** Contact */}
                <div className="contact-form">
                        <h4><FaEnvelope/><span className="etl-icon icon-envelope mbr-iconfont mbr-iconfont-btn"></span>courriel</h4>
                        <ContactForm/>
                </div>
            </div>
            {/** 
            

            <h4>Facebook</h4>
            <p>
            https://www.facebook.com/ASJThonon/
            </p>

            <h4>Verset du mois</h4>
            <q>Recherchez l'Eternel pendant qu'il se laisse trouver! Faites appel à lui tant qu'il est près! <b>(Esaïe 55.6)</b></q>*/}
        </div>
    )
}

export default HomeView;